<script setup>
// A marker for content only internal (Lotus) staff can see. Not a status chip —
// it says nothing about the record's lifecycle, it qualifies the surface it sits
// on — so it deliberately uses the accent tint rather than a status hue, and is
// never clickable.
//
// Colour is not the carrier (D6): the badge always renders its label, and the
// icon is decorative.
import LIcon from '../base/Icon.vue'

defineProps({
	label: { type: String, default: 'Lotus only' },
})
</script>

<template>
	<span class="l-internal-badge">
		<LIcon name="eye-slash" :size="11" />
		{{ label }}
	</span>
</template>

<style scoped>
/* cursor:default is deliberate — this is a label, not a control. */
.l-internal-badge
{
	display: inline-flex;
	align-items: center;
	gap: 5px;
	font-family: var(--font-ui);
	font-size: var(--text-micro);
	font-weight: 600;
	letter-spacing: 0.6px;
	text-transform: uppercase;
	padding: 3px 9px;
	border-radius: var(--r-pill);
	white-space: nowrap;
	cursor: default;
	background: var(--accent-fill);
	color: var(--accent-text);
}
</style>
